import { api } from "lib/graphql/api"
import { gql } from "@apollo/client"
import { query } from "lib/graphql/query"

export const getJobs = api(async function getJobs({ searchTerm = "", skip = 0, take = 10 }) {
    return query(
        gql`
            query JobQuery($searchTerm: String, $skip: Int, $take: Int) {
                getJobs(searchTerm: $searchTerm, skip: $skip, take: $take) {
                    count
                    more
                    data
                }
            }
        `,
        { searchTerm, skip, take },
        { returns: "getJobs" }
    )
})
